module.exports = __webpack_public_path__ + "media/images/flags/16/Uzbekistan-3a4bbac3181586844e3a873599ce8cd3.png";